import {getEnglishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Betygsätt artikeln',
    message: 'Röst mottagen',
    votes: votes => `${getEnglishPlurals(["röst", "röster"], +votes)},`,
    score: 'betyg'
  },
  feedback: {
    label: 'Var den här artikeln till hjälp?'
  }
};